import React, { useEffect, createContext, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { imgUrl, siteUrl } from '../../config/config';
import { getAbout } from '../../store/ducks/about/actions';
import aboutSelector from '../../store/ducks/about/selectors/aboutSelector';
import Page404 from '../../pages/404/404';
import './About.scss';
import { PageMeta } from 'components/PageMeta/PageMeta';

import { LangContext } from '../../components/App/App';

const About = () => {
    const dispatch = useDispatch();
    const about = useSelector(aboutSelector);
    const status = useSelector(state => state.aboutReducer.status);

    const lang = useContext(LangContext);

    useEffect(() => {
        if (lang && lang.lang && lang.lang.value && status === 'IDLE') {
            dispatch(getAbout({ lang: lang.lang.value }));
        }
    }, [lang]);

    if (!about && status === 'SUCCESS') {
        return <Page404 />;
    }

    return (
        <>
            <PageMeta
                title={about && about.title}
                description="Connecting the dots on the global fertilizer market"
            />
            {about && status && status === 'SUCCESS' && (
                <>
                    <section className="main-about">
                        <div className="container">
                            <div className="main-wrapper">
                                <h1
                                    className="main-title"
                                    dangerouslySetInnerHTML={{
                                        __html: about.title,
                                    }}
                                />
                                <div
                                    className="main-description"
                                    style={{
                                        backgroundImage:
                                            "url('" +
                                            siteUrl +
                                            about.image +
                                            "')",
                                    }}
                                >
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: about.caption,
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </section>

                    {about.stats && about.stats.length > 0 && (
                        <section className="facts">
                            <div className="container">
                                <div className="facts-wrapper">
                                    <div className="facts-grid">
                                        {about.stats.map(item => (
                                            <div className="facts-item">
                                                <div className="facts-item__icon">
                                                    <img
                                                        src={
                                                            siteUrl + item.icon
                                                        }
                                                        alt=""
                                                    />
                                                </div>
                                                <div
                                                    className="facts-item__descr"
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.caption,
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </section>
                    )}

                    {about.text && about.text.length > 0 && (
                        <section className="about-history">
                            <div className="container">
                                <div className="about-history__wrapper">
                                    <div className="about-history__content">
                                        <div className="about-history__text">
                                            {about.text.map(item => (
                                                <>
                                                    <h3
                                                        className="block-title"
                                                        dangerouslySetInnerHTML={{
                                                            __html: item.title,
                                                        }}
                                                    />
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                item.description,
                                                        }}
                                                    />
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                    {about.leaders && about.leaders.image && (
                                        <div className="about-history__img">
                                            <img
                                                src={
                                                    siteUrl +
                                                    about.leaders.image
                                                }
                                                alt=""
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </section>
                    )}

                    {about.leaders &&
                        about.leaders.leaders &&
                        about.leaders.leaders.length > 0 && (
                            <section className="team">
                                <div className="container">
                                    <div className="team-wrapper">
                                        <h3
                                            className="block-title"
                                            dangerouslySetInnerHTML={{
                                                __html: about.leaders.title,
                                            }}
                                        />
                                        <div className="team-list">
                                            {about.leaders.leaders.map(item => (
                                                <div className="team-item">
                                                    <div className="team-item__img">
                                                        <img
                                                            src={
                                                                siteUrl +
                                                                item.photo
                                                            }
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="team-item__info">
                                                        <div className="team-item__title">
                                                            <strong>
                                                                {item.name}
                                                            </strong>
                                                            <span>
                                                                {item.position}
                                                            </span>
                                                        </div>
                                                        <div
                                                            className="team-item__descr"
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    item.description,
                                                            }}
                                                        />
                                                    </div>
                                                    <div
                                                        className="team-item__descr-mob"
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                item.description,
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                            {about.leaders.link &&
                                                about.leaders.link.title &&
                                                about.leaders.link.url && (
                                                    <Link
                                                        to={
                                                            about.leaders.link
                                                                .url
                                                        }
                                                        className="team-btn"
                                                    >
                                                        {
                                                            about.leaders.link
                                                                .title
                                                        }
                                                    </Link>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        )}

                    {about.team && about.team.title && (
                        <section className="team team-text">
                            <div className="container">
                                <div className="team-wrapper">
                                    <h3
                                        className="block-title"
                                        dangerouslySetInnerHTML={{
                                            __html: about.team.title,
                                        }}
                                    />
                                    {about.team &&
                                        about.team.text &&
                                        about.team.text.length > 0 &&
                                        about.team.text.map(item => (
                                            <div className="team-list">
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            item.description,
                                                    }}
                                                />
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </section>
                    )}
                </>
            )}
        </>
    );
};

export default About;
